<template lang="pug">
.l-mandara(
  :class="{hotoke:store.ui.state.hotoke,active:active,kirakira:kirakira}"
)
  .l-mandara__btn(
    :class="{hotoke:store.ui.state.hotoke,active:active,kirakira:kirakira}"
    @click="click"
  )
    .l-mandara__btn__front.c-mandarabtn
      .c-mandarabtn__ico
        svg(version="1.1" id="レイヤー_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="246px" height="246px" viewBox="0 0 246 246" enable-background="new 0 0 246 246" xml:space="preserve")
          path(class="petal1" :fill="petalFill(1)" d="M122.7,2c0,0-33.9,8.6-33.9,30.6s20.8,39.6,20.8,39.6l13.1,0.2l13.1-0.2 c0,0,20.8-17.6,20.8-39.6S122.7,2,122.7,2z")
          path(class="petal2" :fill="petalFill(2)" d="M208,37.4c0,0-30-17.9-45.6-2.3S149,77.8,149,77.8l9.1,9.4l9.4,9.1c0,0,27.2,2.2,42.7-13.3 S208,37.4,208,37.4z")
          path(class="petal3" :fill="petalFill(3)" d="M243.2,122.7c0,0-8.6-33.9-30.6-33.9S173,109.6,173,109.6l-0.2,13.1l0.2,13.1 c0,0,17.6,20.8,39.6,20.8S243.2,122.7,243.2,122.7z")
          path(class="petal4" :fill="petalFill(4)" d="M207.8,208c0,0,17.9-30,2.3-45.6S167.4,149,167.4,149l-9.4,9.1l-9.1,9.4c0,0-2.2,27.2,13.3,42.7 S207.8,208,207.8,208z")
          path(class="petal5" :fill="petalFill(5)" d="M122.5,243.2c0,0,33.9-8.6,33.9-30.6S135.6,173,135.6,173l-13.1-0.2l-13.1,0.2 c0,0-20.8,17.6-20.8,39.6S122.5,243.2,122.5,243.2z")
          path(class="petal6" :fill="petalFill(6)" d="M37.3,207.8c0,0,30,17.9,45.6,2.3s13.3-42.7,13.3-42.7l-9.1-9.4l-9.4-9.1 c0,0-27.2-2.2-42.7,13.3S37.3,207.8,37.3,207.8z")
          path(class="petal7" :fill="petalFill(7)" d="M2,122.5c0,0,8.6,33.9,30.6,33.9s39.6-20.8,39.6-20.8l0.2-13.1l-0.2-13.1 c0,0-17.6-20.8-39.6-20.8S2,122.5,2,122.5z")
          path(class="petal8" :fill="petalFill(8)" d="M37.4,37.3c0,0-17.9,30-2.3,45.6s42.7,13.3,42.7,13.3l9.4-9.1l9.1-9.4c0,0,2.2-27.2-13.3-42.7 S37.4,37.3,37.4,37.3z")
          circle(class="circle_ura" fill="#FFFFFF" cx="122.6" cy="122.6" r="59.2")
          circle(class="circle_omote" fill="#515151" cx="122.6" cy="122.6" r="49.6")
          
    .l-mandara__btn__back.c-mandarabtn.gold(:class="{active:active,hotoke:store.ui.state.hotoke}")
      .c-mandarabtn__ico
        svg(version="1.1" id="レイヤー_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="246px" height="246px" viewBox="0 0 246 246" enable-background="new 0 0 246 246" xml:space="preserve")
          path(class="petal1" :fill="petalHotokeFill" d="M122.7,2c0,0-33.9,8.6-33.9,30.6s20.8,39.6,20.8,39.6l13.1,0.2l13.1-0.2 c0,0,20.8-17.6,20.8-39.6S122.7,2,122.7,2z")
          path(class="petal2" :fill="petalHotokeFill" d="M208,37.4c0,0-30-17.9-45.6-2.3S149,77.8,149,77.8l9.1,9.4l9.4,9.1c0,0,27.2,2.2,42.7-13.3 S208,37.4,208,37.4z")
          path(class="petal3" :fill="petalHotokeFill" d="M243.2,122.7c0,0-8.6-33.9-30.6-33.9S173,109.6,173,109.6l-0.2,13.1l0.2,13.1 c0,0,17.6,20.8,39.6,20.8S243.2,122.7,243.2,122.7z")
          path(class="petal4" :fill="petalHotokeFill" d="M207.8,208c0,0,17.9-30,2.3-45.6S167.4,149,167.4,149l-9.4,9.1l-9.1,9.4c0,0-2.2,27.2,13.3,42.7 S207.8,208,207.8,208z")
          path(class="petal5" :fill="petalHotokeFill" d="M122.5,243.2c0,0,33.9-8.6,33.9-30.6S135.6,173,135.6,173l-13.1-0.2l-13.1,0.2 c0,0-20.8,17.6-20.8,39.6S122.5,243.2,122.5,243.2z")
          path(class="petal6" :fill="petalHotokeFill" d="M37.3,207.8c0,0,30,17.9,45.6,2.3s13.3-42.7,13.3-42.7l-9.1-9.4l-9.4-9.1 c0,0-27.2-2.2-42.7,13.3S37.3,207.8,37.3,207.8z")
          path(class="petal7" :fill="petalHotokeFill" d="M2,122.5c0,0,8.6,33.9,30.6,33.9s39.6-20.8,39.6-20.8l0.2-13.1l-0.2-13.1 c0,0-17.6-20.8-39.6-20.8S2,122.5,2,122.5z")
          path(class="petal8" :fill="petalHotokeFill" d="M37.4,37.3c0,0-17.9,30-2.3,45.6s42.7,13.3,42.7,13.3l9.4-9.1l9.1-9.4c0,0,2.2-27.2-13.3-42.7 S37.4,37.3,37.4,37.3z")
          circle(class="circle_ura" :fill="circleUraFill" cx="122.6" cy="122.6" r="59.2")
          circle(class="circle_omote" :fill="circleOmoteFill" cx="122.6" cy="122.6" r="49.6")
          radialGradient(id="MANDARA_GRADIENT" cx="122.6" cy="123.4" r="49.6" gradientTransform="matrix(1 0 0 -1 0 246)" gradientUnits="userSpaceOnUse")
            stop(offset="0" style="stop-color:#FFFFFF")
            stop(offset="1" style="stop-color:#A28A3E")

</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

@keyframes kirakiramotion
  0%
    transform rotate3d(0,1,0,0deg) translate3d(0,0px,0)
  50%
    transform rotate3d(0,1,0,90deg) translate3d(0,-10px,0)
  100%
    transform rotate3d(0,1,0,180deg) translate3d(0,0px,0)

// @keyframes kirakiramotionopacity
//   0%
//     opacity 0
//   50%
//     opacity 0
//   51%
//     opacity 1
//   100%
//     opacity 1


.c-mandarabtn
  background-color #e6e6e6
  border-radius 50%
  display block
  position relative
  
  no_highlight()

  &.gold
    background linear-gradient(60deg,#816202, #fffce9 , #816202)
    // background-color #FFF
    opacity 0.5
    &:after
      background-color #fbf8e5
      // background-color #404040
  &.gold.hotoke
    background none
    background-color #FFF
    &:after
      background-color #404040

  +pc()
    wh(72px)
  +sp()
    wh(82px)
   
  &.active
    opacity 1
    +pc()
      box-shadow 0 4px 6px rgba(150,150,150,0.45)
    +sp()
      box-shadow 0 4px 6px rgba(150,150,150,0.45)
  &:after
    content ""
    posc()
    background-color #FFF
    border-radius 50%
  
  &__ico
    posc(10)
    wh(60%)
    svg
      wh()


.l-mandara
  no_highlight()
  +pc()
    posrb(18px,25px,20)
    wh(70px)

    &.active
      cursor pointer
      transition transform 400ms $easeOutBack
      &:hover
        transform scale(1.1)

  +sp()
    posrb(18px,50px,20)
    wh(116px)


  &__btn
    no_highlight()
    posrb()
    wh()

    transform-style preserve-3d
    &.kirakira
      animation-name kirakiramotion
      animation-duration 500ms
      animation-fill-mode forwards
      animation-delay 500ms

    // &.active
    //   cursor pointer
    //   transition transform 400ms $easeOutBack
    //   &:hover
    //     transform scale(1.1)
    &__front,
    &__back
      backface-visibility hidden
      posrb()
      +pc()
        wh(70px)
        &:after
          wh(64px)
      +sp()
        wh(116px)
        &:after
          wh(108px)
    &__back
      transform rotate3d(0,1,0,180deg)
      // opacity 0
      // ^[1].kirakira &
      //   animation-name kirakiramotionopacity
      //   animation-duration 500ms
      //   animation-fill-mode forwards
      //   animation-delay 500ms



</style>


<script>
import { defineComponent, computed, reactive } from "vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'


export default defineComponent({
  name:'Mandara',

  components:{},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    const petalFill = computed(()=>{
      return (num)=>{
        let color = store.ui.state.hotokeCount >= num ? '#e9470a' : '#515151'
        return color
      }
    })
    const petalHotokeFill = computed(()=>{
      return store.ui.state.hotoke ? '#FFFFFF' : '#a28a3e'
    })
    const circleUraFill = computed(()=>{
      return store.ui.state.hotoke ? '#404040' : '#FBF8E5'
    })
    const circleOmoteFill = computed(()=>{
      return store.ui.state.hotoke ? '#FFFFFF' : 'url(#MANDARA_GRADIENT)'
    })
    const active = computed(()=>{
      return store.ui.state.hotokeCountCheck && store.ui.state.maptype != 1
    })
    const kirakira = computed(()=>{
      return store.ui.state.hotokeCountCheck && !store.ui.state.article.show
    })
    
    const click = ()=> {
      if(store.ui.state.hotokeCountCheck && store.ui.state.maptype != 1){
        store.ui.state.hotoke = !store.ui.state.hotoke
        if(store.ui.state.maptype == 2){
          router.push('/map3')
        } else if(store.ui.state.maptype == 4){
          router.push('/map5')
        }
      }
    }

    return{
      store,
      petalFill,
      petalHotokeFill,
      circleUraFill,
      circleOmoteFill,
      kirakira,
      active,
      click
    }
  }
})
</script>
